
export const shortenString = (text: string, isFull: boolean, targetLength: number = 1000): [boolean, string] => {
    const needsShortening = text.length > targetLength

    if (isFull) {
        return [needsShortening, text]
    }

    return [needsShortening, needsShortening ? text.slice(0, targetLength) + '...' : text]
}
